import { render } from "./SelectedGroupForm.vue?vue&type=template&id=b02b5e68"
import script from "./SelectedGroupForm.vue?vue&type=script&lang=js"
export * from "./SelectedGroupForm.vue?vue&type=script&lang=js"

import "./SelectedGroupForm.vue?vue&type=style&index=0&id=b02b5e68&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__